module.exports = __webpack_public_path__ + "img/megafono.ac4a84f2.png";